<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6s0HCN/tc-custom/9781593706487.jpg?1706297158998" alt="This image is the cover for the book Introduction to Well Logs & Subsurface Maps, 2nd Edition"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Introduction to Well Logs & Subsurface Maps, 2nd Edition
      </h1>
      <p class="bookDescription body article font2">
        <p>Subsurface mapping is a way to visualize and spatially characterize subsurface properties, and well logs are often the dataset used to generate and calibrate these maps. The correlation of basic geophysical logs rapidly enables oneself to begin to illustrate and understand the one-dimensional to 3D distribution of various properties.<br/> <br/> The second edition of Dr. Jonathan Evenick's book covers many types of basic well logs and subsurface maps. This book will help you quickly understand what many of these well logs are measuring and how they can be used to produce various subsurface maps. Three additional chapters and exercises have been included on spectral gamma ray logs, fault seal, geothermal energy, and source rock maps (unconventional resources).<br/> <br/> Features and Benefits</p>  Introduction to basic well logs and subsurface maps Applied exercises at that the end of each chapter Additional topics and materials have been included (i.e., spectral gamma ray logs, unconventional resources, geothermal maps, fault seal, paleogeographic maps, and resource uncertainty). Well log and subsurface mapping exercises for use in subsurface mapping, well logging, petroleum, hydrogeology, mining, and geothermal energy courses. *Full answer key available by request.  <p><br/> Audience</p>  Geologists Geophysicists Petroleum and reservoir engineers Hydrogeologists Environmental consultants 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonathan C. Evenick
      </h2>
      
      <p class="authorDescription body article">Jonathan C. Evenick works as a basin analyst-structural geologist for BP America Inc. in Houston for 11 years. In his career, he has mapped and screened about 200 onshore and offshore sedimentary basins for various resources and opportunities (e.g., unconventional source rock and conventional hydrocarbon plays, geothermal energy, mineral, and carbon capture).<br > <br > Dr. Evenick received a Ph.D. in geology from the University of Tennessee, M.S. from the University of Buffalo, and B.S. from Fredonia State College. He has written many articles related to integrated subsurface mapping, geophysical log correlations, and petroleum systems. He is a member of the American Association of Petroleum Geologists and the Geological Society of America.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PennWell
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52940e48